import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdAssignment, MdPerson } from 'react-icons/md';
import { FaWarehouse, FaHome, FaMapMarkerAlt } from 'react-icons/fa';
import './style.css';

function TerminalProducao() {
  const navigate = useNavigate();
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  useEffect(() => {
    // Função para carregar usuário do localStorage
    const carregarUsuario = () => {
      const usuarioSalvo = localStorage.getItem('usuarioSelecionado');
      if (usuarioSalvo) {
        try {
          setUsuarioSelecionado(JSON.parse(usuarioSalvo));
        } catch (error) {
          console.error('Erro ao carregar usuário do localStorage:', error);
        }
      } else {
        setUsuarioSelecionado(null);
      }
    };

    // Carregar usuário ao montar
    carregarUsuario();

    // Listener para detectar mudanças no localStorage (quando o usuário é selecionado em outra aba)
    const handleStorageChange = (e) => {
      if (e.key === 'usuarioSelecionado') {
        carregarUsuario();
      }
    };

    // Escutar mudanças no localStorage
    window.addEventListener('storage', handleStorageChange);

    // Escutar mudanças customizadas (para a mesma aba)
    window.addEventListener('usuarioSelecionadoChanged', carregarUsuario);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('usuarioSelecionadoChanged', carregarUsuario);
    };
  }, []);

  return (
    <div className="TerminalProducao-container">
      {/* Header original mantido */}
      <header className="header-container-landing-page">
        <div className="header-logo-center-landing-page">
          <label className="header-logo-center-label-landing-page">Syncs</label>
        </div>
      </header>

      {/* Exibir usuário selecionado */}
      {usuarioSelecionado && (
        <div style={{
          margin: '20px auto',
          maxWidth: '600px',
          padding: '15px 20px',
          background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
          borderRadius: '12px',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          alignItems: 'center',
          gap: '12px'
        }}>
          <MdPerson style={{ fontSize: '24px', color: '#2e7d32' }} />
          <div style={{ flex: 1 }}>
            <p style={{ margin: '0', fontSize: '14px', color: '#666', fontWeight: '500' }}>
              Usuário Ativo:
            </p>
            <p style={{ margin: '4px 0 0 0', fontSize: '16px', fontWeight: '600', color: '#2c3e50' }}>
              <strong>ID:</strong> {usuarioSelecionado.ID_USUARIO} - <strong>Nome:</strong> {usuarioSelecionado.DS_NOME}
            </p>
          </div>
        </div>
      )}

      <div className="TerminalProducao-buttons-area">

      <button
          className="TerminalProducao-button"
          onClick={() => navigate('/home')}
        >
          <FaHome className="TerminalProducao-icon" />
          <span className="TerminalProducao-label">Home</span>
        </button>

        <button
          className="TerminalProducao-button"
          onClick={() => navigate('/producao')}
        >
          <MdAssignment className="TerminalProducao-icon" />
          <span className="TerminalProducao-label">Ordem de Produção</span>
        </button>

        <button
          className="TerminalProducao-button"
          onClick={() => navigate('/estoque')}
        >
          <FaWarehouse className="TerminalProducao-icon" />
          <span className="TerminalProducao-label">Estoque</span>
        </button>

        <button
          className="TerminalProducao-button TerminalProducao-button-local"
          onClick={() => navigate('/estoque?modo=local')}
        >
          <FaMapMarkerAlt className="TerminalProducao-icon" />
          <span className="TerminalProducao-label">Expedição Wolff</span>
        </button>
      </div>
    </div>
  );
}

export default TerminalProducao;
